import { Options } from '@angular-slider/ngx-slider';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { ApiService } from '../../shared/services/apiService.service'
import { secureStorage } from '../../shared/services/encryption/secureservice';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviourSubjectService } from '../../shared/services/behaviour-subject.service';
import { isPlatformBrowser } from '@angular/common';
import { RootService } from '../../shared/services/root.service';
import { environment } from '../../../environments/environment' //'src/environments/environment';

interface Feature {
  name: string;
  includedIn: string[];
}
@Component({
  selector: 'app-booking-amc-list',
  templateUrl: './booking-amc-list.component.html',
  styleUrls: ['./booking-amc-list.component.scss'],
})
export class BookingAmcListComponent implements OnInit {
  environment1 = environment.s3bucket.url;
  amcPlan: any;
  vc_no: any;
  applicationName: any;
  terrain: any;
  amcData: any;
  annual_kms: any[] = [];
  amc_duration: any[] = [];
  amc_type: any[] = [];
  firstAnnualValue: any;
  lastAnnualValue: any;
  year: any = [];
  kms: any = [];
  isAMC: boolean = false;
  carddata: any;
  isUserLoggedIn: boolean;
  userData: any;
  productId: string;
  breadcrumbData: string[];
  lobSeo: string;
  subLob: string;
  pplSeo: string;
  model: string;
  productDetailList: any;
  annual_kmsroute: any;
  amc_durationroute: any;
  terrainroute: any;
  applicationrote: any;
  sliderData: any;
  isHCV: boolean=false;
  annualKmhr: string;
  currentUrl: string;
  extendedArrayData: any = [];
  isStepVisible: boolean = false;
  breadcrumbList: { label: string; url: string; pageName: string; };
  breadcrumbdata: any = [];
  showBreadCrumb: boolean = false;
  osp_configurator_request:any;
  osp_configurator_response:any;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private localStorage: secureStorage,
    private apiService: ApiService,
    private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
    private behaviorService: BehaviourSubjectService,
    private rootService: RootService,
    private router: Router
  ) {}
  value = 205000;
  goldFeature = [
    'All maintenance services as stated in OSB.',
    'All lubricant, filters and parts replacement as mentioned in OSB on scheduled services.',
    'All labor charges for servicing and mechanical/electrical repairs.',
    'All the Labor for major aggregate overhauling - Engine, Gearbox, Differential',
    'All servicing of ancillary parts like alternator, starter, fuel pump.'
  ];
  silverFeature = [
    'All the scheduled maintenance services as stated in OSB.',
    'All lubricant, filters and parts replacement as mentioned in OSB on scheduled services.',
  ];
  platinumFeature = [
    'All maintenance services as stated in OSB.',
    'All lubricant, filters and parts replacement as mentioned in OSB on scheduled services.',
    'All the major aggregate overhauling - Engine, Gearbox, Differential.',
    'All servicing of ancillary parts like alternator, starter, fuel pump.',
  ];

  platinumplusFeature = [
    'All maintenance services as stated in OSB.',
    'Change of lubricant, filters and other scheduled parts replacement as mentioned in OSB.',
    'Preventive checks, minor repairs and adjustments.',
   ' All labour as well as parts required for mechanical/electrical repairs.',
   'All the major aggregate overhauling - Engine, Gearbox, Differential.',
  ' All servicing of ancillary parts like alternator, starter, fuel pump.'
  ];
  goldplusFeature = [
    'All Maintenance Services as state in OSB.',
    'All lubricant, filters and parts replacement as mentioned in OSB on scheduled services.',
    'Repairs and Maintenance of wear and tear items –  Clutch, Brake, and Flywheel.',
   ' Servicing and repair of Ancillary part Alternator and Starter Motor.',
   ' Highway support in case of breakdown of vehicle.',
  ];
  FMSPackOneFeature = [
    'All maintenance services as stated in OSB.',
    'All lubricant, filters and parts replacement as mentioned in OSB on scheduled services.',
    'All the major aggregate overhauling - Engine, Gearbox, Differential.',
    'All servicing of ancillary parts like alternator, starter, fuel pump, SCR Module, DOC Module, DPF Module, Wiring Harness(Chassis, Engine & Dashboard only)',
    'Quarterly Torqueing of all bolts, Quarterly Greasing, Engine Oil and Coolant Top ups.'
  ];
  FMSPackTwoFeature = [
    'All maintenance services as stated in OSB.',
    'All lubricant, filters and parts replacement as mentioned in OSB on scheduled services.',
    'All the major aggregate overhauling - Engine, Gearbox, Differential.',
    'All servicing of ancillary parts like alternator, starter, fuel pump, SCR Module, DOC Module, DPF Module, Wiring Harness(Chassis, Engine & Dashboard only)',
    'All servicing of electrical parts like Battery, ECUs, relays and bulbs.',
    'Quarterly Torqueing of all bolts, Quarterly Greasing, Engine Oil and Coolant Top ups.'
  ];

  currentStep = 1;
  isVisible: boolean = false;
  priceOfExtendedWarranty: number | undefined;
  currentIndex: any;
  selectedTenurePlan: any;
  selectedAnnualRunning: any;
  selectedCard: any;
  isExtendedWarrantyChecked: boolean = false;
  selectedPlan: any;

  value1: number = 1000;
  value2: number = 1;
  sub: Subscription = new Subscription();
  NewLob: any;
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.currentUrl = window.location.href;
      localStorage.removeItem('VASData')
    }
    this.sub.add(
      this.behaviorService.isLoggedIn.subscribe(() => {
        this.isUserLoggedIn = this.rootService.isLoggedIn() ? true : false;
        this.userData = this.rootService.getUserData();
      })
    );
    this.extendedArrayData = JSON.parse(localStorage.getItem('extendedVas'))
    const index = this.extendedArrayData?.amcDataArray?.findIndex(obj => obj?.plan?.toLowerCase().split(' ').includes('amc'));
    if (index !== -1) {
      this.extendedArrayData?.amcDataArray?.splice(index, 1);
    }
    this.extendedArrayData = this.extendedArrayData?.amcDataArray ? this.extendedArrayData?.amcDataArray : [];
    this.isStepVisible = this.extendedArrayData?.length === 0 ? false : true;
    this.activatedRoute.paramMap.subscribe((params) => {
      this.vc_no = params.get('vc');
      this.annual_kmsroute = params.get('annual_kms');
      this.amc_durationroute = params.get('amc_duration');
      this.terrainroute = params.get('terrain');
      this.applicationrote = params.get('application');
      if (params.get('id')) {
        this.productId = params.get('id');
        this.breadcrumbData = [
          params.get('lob_seo'),
          params.get('sub_lob'),
          params.get('ppl_seo'),
          params.get('model'),
        ];
        this.lobSeo = params.get('lob_seo');
        this.subLob = params.get('sub_lob');
        this.pplSeo = params.get('ppl_seo');
        this.model = params.get('model');
      }
       this.annualKmhr= this.subLob=="hcv-const" ? 'Annual Contract Hrs-' : 'Annual Contract Km-'
    });
    this.getVehicleDetail();

    // this.confirmandnext();
    // this.extendWarranty();
    this.priceOfExtendedWarranty = this.carddata?.price_of_extended_warranty;
    setTimeout(() => {
      this.breadcrumb();
    }, 1000);
  }

  options: Options = {
    floor: 1000,
    ceil: 5000,
    step: 500,
    showTicks: true,
    showTicksValues: true,
    tickValueStep: 500,
    ticksTooltip: (v: number): string => `${v}`,
    translate: (value: number): string => {
      return value + ' ';
    },
  };
  options1: Options = {
    floor: 1,
    ceil: 5,
    step: 1,
    showTicks: true,
    showTicksValues: true,
    tickValueStep: 1,
    ticksTooltip: (v: number): string => `${v} `,
    translate: (value: number): string => {
      return value + ' ';
    },
  };

  getVehicleDetail() {
    let data;
        if (this.vc_no) {
          data = {
            vehicle_number: this.vc_no,
          };
        }
        this.sub.add(
          this.apiService.getVehicleDetails(data).subscribe({
            next: (res: any) => {
             this.productDetailList = res?.data;
             let lobValue;
              switch (this.productDetailList?.lob) {
                case 'hcv-const':
                case 'hcv-cargo':
                  case 'HCV Const':
                    case 'HCV Cargo':
                  lobValue = 'hcv';
                  break;
                case 'bus':
                  case 'BUSES':
                    case 'Buses':
                  lobValue = 'bus';
                  break;
                case 'magic':
                  lobValue = 'tata_magic';
                  break;
                case 'winger':
                  case 'SCPASS':
                  lobValue = 'winger';
                  break;
                case 'hcv':
                  lobValue = 'hcv';
                  break;
                case 'ilmcv':
                  lobValue = 'ilmcv';
                  break;
                case 'scv':
                  case 'SCV CARGO':
                  lobValue = 'scv';
                  break;
                case 'ScPass':
                  lobValue = 'winger';
                  break;
                case 'SCVPass':
                  lobValue = 'tata_magic';
                  break;
                case 'SCV Cargo':
                  lobValue = 'scv';
                  break;
                case 'Pickups':
                  case 'PICKUPS':
                case 'Yodha & Intra':
                  lobValue = 'scv';
                  break;
                case 'mcv-trucks':
                case 'icv':
                case 'mhcv':
                  case 'MCV Trucks':
                  case 'ICV Trucks':
                    case 'LCV':
                  lobValue = 'ilmcv';
                  break;
                default:
                  lobValue = this.productDetailList?.lob;
                  break;
              }
              this.NewLob = lobValue;
             this.confirmandnext()
            },
            error: () => {

            },
            complete: () => {
            },
          })
        );
      }

  clickCard(index: number) {
    this.currentIndex = index;
    this.selectedPlan = this.amcData[index];
    this.bindSelectedPlanValues();
  }
  selectPlan(plan: any) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('VASData')
    }
    this.selectedPlan = plan;
    this.value2 = this.selectedPlan.amc_duration;
    this.bindSelectedPlanValues();
    this.sliderDatachange();
   this.submitData()
    // this.setStep(2);
    // this.extendWarranty(); // This is already fetching the warranty data
  }
  bindSelectedPlanValues() {
    if (this.selectedPlan) {
      this.value1 = this.selectedPlan?.annual_kms;
      this.value2 = this.selectedPlan?.amc_duration;
      // this.options = { ...this.options };
      // this.options1 = { ...this.options1 };
    }
  }
  setStep(step: number) {
    this.currentStep = step;
    if (this.currentStep == 2) {
      this.isVisible = true;
    } else {
      this.isVisible = false;
    }
  }
  confirmandnext() {
    try {
      let data = {
        output_type: 'all',
        application: this.applicationrote?.replace(/-/g, '/')?.replace(/#/g,'-'),
        terrain: this.terrainroute?.replace(/-/g, '/')?.replace(/&/g,'-'),
        vc_no: this.vc_no,
        amc_duration: this.amc_durationroute,
        annual_kms: this.annual_kmsroute,
        pl: this.productDetailList?.pl,
        lob_name: this.NewLob?.toLowerCase(),
      };
      this.osp_configurator_request = data;
      this.sub.add(
        this.apiService.getAMCData(data).subscribe({
          next: (response: any) => {
            this.spinner.hide();
            this.osp_configurator_response = response;
            if (response.STATUS === 'SUCCESS') {
              localStorage.removeItem('amcPlan');
              let annual_kms = [];
              let amc_duration = [];
              const sortedAndUniqueData = this.processAMCData(response.RESPONSE.DATA);
              this.amcData = sortedAndUniqueData;
              this.amc_type = this.amcData;
              this.value = this.amcData[0]?.amount_payable;
              this.amcData.forEach((element) => {
                annual_kms.push(element.annual_kms);
                amc_duration.push(element.amc_duration);
              });
              this.annual_kms = [...new Set(annual_kms)].sort();
              this.amc_duration = [...new Set(amc_duration)].sort();
              this.kms = this.annual_kms;
              this.year = this.amc_duration;
              this.value1 = Number(this.kms);
              this.value2 = Number(this.year[0]);
              // this.siderdata();
            } else {
              this.spinner.hide();
              this.amc_type = [];
              this.amc_duration = [];
              this.annual_kms = [];
            }
          },
        })
      );
    } catch (error) {
      console.error(error);
    }
  }
  processAMCData(data: any[]) {
    const sortedData = data.sort((a, b) => a.amount_payable - b.amount_payable);
    const uniqueData = sortedData.filter((item, index, self) =>
      index === self.findIndex((t) => t.amount_payable === item.amount_payable)
    );

    return uniqueData;
  }

  siderdata() {
    try {
      let data = {
        output_type: 'all',
        application: this.applicationrote?.replace(/-/g, '/').replace(/#/g,'-'),
        terrain: this.terrainroute.replace(/-/g, '/').replace(/&/g,'-'),
        vc_no: this.vc_no,
      };
      this.sub.add(
        this.apiService.getAMCData(data).subscribe({
          next: (response: any) => {
            this.spinner.hide();
            if (response.STATUS == 'SUCCESS') {
              localStorage.removeItem('amcPlan');
              let annual_kms = [];
              let amc_duration = [];
              this.sliderData = response.RESPONSE.DATA;
              this.value = this.amcData[0].amount_payable;
              this.sliderData.forEach((element) => {
                annual_kms?.push(element?.annual_kms);
                amc_duration?.push(element?.amc_duration);
              });

              this.annual_kms = [...new Set(annual_kms)];
              this.amc_duration = [...new Set(amc_duration)];
              this.kms = this.annual_kms.sort();
              this.year = this.amc_duration.sort();
              this.value1 = Number(this.kms[1]);
              this.options = {
                floor: Number(this.kms[0]),
                ceil: Number(this.kms[this.kms?.length - 1]),
                stepsArray: [],
                showTicks: true,
                showTicksValues: true,
                ticksTooltip: (v: number): string => `${v} Kms`,
              };
              this.generateStepsArraykms();
              this.value2 = Number(this.year[1]);
              this.options1 = {
                floor: Number(this.year[0]),
                ceil: Number(this.year[this.year?.length - 1]),
                showTicks: true,
                showTicksValues: true,
                ticksTooltip: (v: number): string => `${v} `,
              };
              this.generateStepsArray();
            } else {
              this.spinner.hide();
              this.amc_type = [];
              this.amc_duration = [];
              this.annual_kms = [];
            }
          },
        })
      );
    } catch (error) {}
  }

 async submitData() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('VASData')
    }
    let vasSelectedData= {
      AnnualKms: this.selectedPlan?.annual_kms,
      Exshowroomprice: this.value, // need to confirm
      LOB: this.lobSeo,
      NoOfyears: this.value2,
      SubLob: this.subLob,
      VASBookingAmount: (this.subLob =="scv-cargo" || this.subLob =="pickups" || this.subLob =="scvpass" || this.subLob == "scv-pickups" || this.subLob =="scpass") ? 1000 : 2000,
      VASPLAN: this.selectedPlan?.amc_type,
      VASTotalAmount: this.value, // need to confirm
      VCNUMBER: this.vc_no,
      VasAvailable: "YES",
      crmApplication: '',
      fuel_type: "", // need to ask
      isViaConfigurator: true,
      isViaOSPVas:true,
      openPage: "booking",
      taggedVC: [],
      recommended_quantity:  localStorage.getItem('quantity'),
      terrian: this.activatedRoute.snapshot.paramMap.get('terrain'),
      vasApplication: this.activatedRoute.snapshot.paramMap.get('application'),
      is_amc:true
    }
    this.localStorage.setItem('amcListSelected',JSON.stringify(vasSelectedData))
    this.localStorage.setItem('VASData',JSON.stringify(vasSelectedData));
    this.localStorage.setItem('amcBookingListUrl',JSON.stringify(window.location.href));
    this.behaviorService.updateSubmissionData();
    let id = localStorage.getItem('tat_id');
    if (id !== null && id !== undefined) {
    try {
      await this.vastatrequestresponsereturn(); // Wait for API response
    } catch (error) {
      console.error("Error in vastatrequestresponse:", error);
    }
  }
    if (this.isUserLoggedIn) {
      let sub_lob =this.subLob.replace(/\s/g, '-')?.toLowerCase() == 'icv-trucks' ? 'trucks' : this.subLob.replace(/\s/g, '-')?.toLowerCase() == 'buses' ? 'buses-vans' : this.subLob.replace(/\s/g, '-')?.toLowerCase();
      let model = this.model
        .replace(/\s/g, '-')
        .replace(/\//g, '-')
        .replace(/\+/g, '-')
        .replace(/\./g, '-')
        ?.toLowerCase();
        if(this.currentUrl.split('/').includes('trucks')){
          this.router.navigate([
            '/extended-vas/' +
              sub_lob +
              '/' +
              this.lobSeo +
              '/' +
              this.pplSeo +
              '/' +
              model +
              '/' +
              this.productId +
              '/' +
              this.selectedPlan?.amount_payable
          ]);
        }else{
          this.router.navigate([
            '/lead-booking/' +
              sub_lob +
              '/' +
              this.lobSeo +
              '/' +
              this.pplSeo +
              '/' +
              model +
              '/' +
              this.productId,
          ]);
        }
    }

  }
  generateStepsArray(): void {
    this.options1.stepsArray = this.year.map((value, index) => {
      return { value };
    });
  }
  generateStepsArraykms(): void {
    this.options.stepsArray = this.kms.map((value, index) => {
      return { value };
    });
  }

  seeFull() {
    this.isAMC = true;
  }

  // extendWarranty() {
  //   try {
  //     let data = {
  //       vc_no: this.vc_no,
  //     };
  //     this.sub.add(
  //       this.apiService.getWarranty(data).subscribe({
  //         next: (response) => {
  //           // this.spinner.hide();
  //           this.carddata = response.data;
  //         },
  //         error: () => {
  //           this.isAMC = false;
  //         },
  //         complete: () => {},
  //       })
  //     );
  //   } catch (error) {}
  // }
  onSliderChange() {
    this.sliderDatachange();
  }

  sliderDatachange() {
    this.selectedTenurePlan = this.value1;
    this.selectedAnnualRunning = this.value2;
    try {
      let data = {
        output_type: 'all',
        application: this.applicationrote?.replace(/-/g, '/').replace(/#/g,'-'),
        terrain: this.terrainroute.replace(/-/g, '/').replace(/&/g,'-'),
        vc_no: this.vc_no,
        amc_duration: this.value2,
        annual_kms: this.value1,
      };
      this.sub.add(
        this.apiService.getAMCData(data).subscribe({
          next: (response: any) => {
            this.spinner.hide();
            if (response.STATUS == 'SUCCESS') {
              localStorage.removeItem('amcPlan');
              let basePrice = parseFloat(
                response.RESPONSE.DATA[0].amount_payable
              );
              let extendedWarrantyPrice =
                this.isExtendedWarrantyChecked &&
                this.carddata &&
                this.carddata[0].price_of_extended_warranty
                  ? parseFloat(this.carddata[0].price_of_extended_warranty)
                  : 0;

              this.value = basePrice + extendedWarrantyPrice;
            } else {
              this.spinner.hide();
            }
          },
        })
      );
    } catch (error) {
      console.error('Error in sliderDatachange:', error);
    }
  }

  bookNow() {
    if (this.isUserLoggedIn) {
      let sub_lob =
        this.subLob.replace(/\s/g, '-')?.toLowerCase() == 'icv-trucks'
          ? 'trucks'
          : this.subLob.replace(/\s/g, '-')?.toLowerCase() == 'buses'
          ? 'buses-vans'
          : this.subLob.replace(/\s/g, '-')?.toLowerCase();
      let model = this.model
        .replace(/\s/g, '-')
        .replace(/\//g, '-')
        .replace(/\+/g, '-')
        .replace(/\./g, '-')
        ?.toLowerCase();
      this.router.navigate([
        '/lead-booking/' +
          sub_lob +
          '/' +
          this.lobSeo +
          '/' +
          this.pplSeo +
          '/' +
          model +
          '/' +
          this.productId,
      ]);
    } else {
      let sub_lob =
        this.subLob.replace(/\s/g, '-')?.toLowerCase() == 'icv-trucks'
          ? 'trucks'
          : this.subLob.replace(/\s/g, '-')?.toLowerCase() == 'buses'
          ? 'buses-vans'
          : this.subLob.replace(/\s/g, '-')?.toLowerCase();
      let model = this.model
        .replace(/\s/g, '-')
        .replace(/\//g, '-')
        .replace(/\+/g, '-')
        .replace(/\./g, '-')
        ?.toLowerCase();
      if (isPlatformBrowser(this.platformId)) {
        localStorage.setItem(
          'previousUrl',
          '/lead-booking/' +
            sub_lob +
            '/' +
            this.lobSeo +
            '/' +
            this.pplSeo +
            '/' +
            model +
            '/' +
            this.productId
        );
      }
      this.router.navigate(['/login/']);
    }
  }


  getAmcTypeImage(amcType: string): string {
    // Normalize amc_type to ensure it follows the specified pattern
    if (amcType === 'FMS-1' || amcType === 'FMS Pack-1') {
      return 'fms_pack-1';
    } else if (amcType === 'FMS-2' || amcType === 'FMS Pack-2') {
      return 'fms_pack-2';
    }
    return amcType?.toLowerCase().replace(/\s+/g, '_');
  }

  getAmcTypeDisplay(amcType: string): string {
    // Standardize the display name for FMS types
    if (amcType === 'FMS-1' || amcType === 'FMS Pack-1') {
      return 'FMS Pack-1';
    } else if (amcType === 'FMS-2' || amcType === 'FMS Pack-2') {
      return 'FMS Pack-2';
    }
    return amcType;
  }
  breadcrumb() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('localBreadCrumb');
    }
    this.breadcrumbList = {
      label:
        this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
        'icv-trucks'
          ? 'Trucks'
          : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
            'buses'
          ? 'Buses & Vans'
          : this.productDetailList.sub_lob,
      url:
        `/product-list/` +
        (this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
        'icv-trucks'
          ? 'trucks'
          : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
            'buses'
          ? 'buses-vans'
          : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase()),
      pageName: 'booking-amc-list',
    };

    this.breadcrumbdata.push(this.breadcrumbList);

    this.breadcrumbList = {
      label: this.productDetailList.lob,
      url:
        `/product-list/` +
        (this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
        'icv-trucks'
          ? 'trucks'
          : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
            'buses'
          ? 'buses-vans'
          : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase()) +
        `/` +
        this.productDetailList.lob?.replace(/\s/g, '-')?.toLowerCase(),
      pageName: 'booking-amc-list',
    };
    this.breadcrumbdata.push(this.breadcrumbList);

    this.breadcrumbList = {
      label: this.productDetailList.ppl,
      url:
        `/product-list/` +
        (this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
        'icv-trucks'
          ? 'trucks'
          : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
            'buses'
          ? 'buses-vans'
          : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase()) +
        `/` +
        this.productDetailList.lob?.replace(/\s/g, '-')?.toLowerCase() +
        `/` +
        this.productDetailList.ppl
          ?.replace(/\s/g, '-')
          .replace('---', '-')
          .replace('/', '-')
          ?.toLowerCase(),
      pageName: 'booking-amc-list',
    };
    this.breadcrumbdata.push(this.breadcrumbList);

    this.breadcrumbList = {
      label: this.productDetailList.model,
      url: '',
      pageName: 'product-details',
    };
    this.breadcrumbdata.push(this.breadcrumbList);
    if (isPlatformBrowser(this.platformId)) {
      this.localStorage.setItem(
        'localBreadCrumb',
        JSON.stringify(this.breadcrumbdata)
      );
    }
    this.showBreadCrumb = true;
  }
  vastatrequestresponsereturn(data?): Promise<any> {
    return new Promise((resolve, reject) => {
      let id = localStorage.getItem('tat_id');
      let Payload = {
        "id": id ? id:'',
        "home_configurator_request":"",
        "home_configurator_response":"" ,
        "osp_configurator_vas_filter_request":this.osp_configurator_request ? this.osp_configurator_request : '',
        "osp_configurator_vas_filter_response":this.osp_configurator_response ? this.osp_configurator_response : '',
        "request_id": "",
        "vehicle_number":this.productDetailList?.vehicle_number ? this.productDetailList?.vehicle_number :'',
        "model": this.productDetailList?.model ? this.productDetailList?.model : '',
        "number_of_vehicles": "",
        "application": this.applicationrote ? this.applicationrote : '',
        "terrain":this.terrainroute ? this.terrainroute : '',
        "annual_runnig":this.annual_kmsroute ? this.annual_kmsroute : '',
        "duration_of_amc":this.amc_durationroute ? this.amc_durationroute : '',
        "vas_offer":this.selectedPlan?.amc_type ? this.selectedPlan?.amc_type :'',
        "amc": "",
        "fms": "",
        "ew": "",
        "oss": "",
        "fleetedge": "",
        "uptime_guarantee": "",
        "source": "",
        "vas_booking_price":this.selectedPlan?.amount_payable ? this.selectedPlan?.amount_payable : ''
      };

      this.spinner.show();

      this.apiService.getvastat(Payload).subscribe({
        next: (res: any) => {
          this.spinner.hide();
          if (res?.success) {
            resolve(res);
          } else {
            reject("API call failed.");
          }
        },
        error: (error: any) => {
          this.spinner.hide();
          reject(error);
        },
        complete: () => {
          this.spinner.hide();
        }
      });
    });
  }


}
